
<template>
    <div :disabled="disabled || spinning">
        <button-button v-show="!disabled && !spinning" type="button" class="btn-close"></button-button>
        <div v-show="spinning">
            <fa-icon icon="spinner" class="fa-spin me-2" />
        </div>
    </div>
</template>

<script lang="ts">

import { defineComponent } from "vue";

export default defineComponent({
    props: {
        disabled: { type: Boolean, required: false, default: false },
        spinning: { type: Boolean, required: false, default: false },
    },
});

</script>
